export const  successummit = {
    error: false,
    data: {
      bitacoraId: null,
      leadId: "00QU900000Aqm1BMAR",
      tenant: false,
      errorCode: "INVOKE-200",
      error: "OK"
    }
}

export const successummitBitacora = {
  error: false,
  data: {
    leadId: "00Qdq0000019d1aEAA",
    bitacoraId: "4AS42ZSDD00010A0A1",
    tenant: false,
    errorCode: "INVOKE-200",
    error: "OK"
  }
};

export const successummitMasdedosPolizas = {
  error: false,
  data: {
    leadId: "00Qdq0000019h0MEAQ",
    cuantity: 2,
    tenant: true,
    errorCode: "INVOKE-200",
    error: "OK"
  }
};

export const successummitMasdedosPolizasBitacora = {
  error: false,
  data: {
    leadId: "00Qdq0000019h0MEAQ",
    bitacoraId: "4AS42ZSDD00010A0A1",
    cuantity: 2,
    tenant: true,
    errorCode: "INVOKE-200",
    error: "OK"
  }
}